import { useState, useEffect } from 'react';
import { useApi, configApiRef, identityApiRef } from '@backstage/core-plugin-api';

export interface ConfluencePage {
  title: string;
  html: string;
}

export function useConfluencePage(pageId: string | null) {
  const configApi = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const baseUrl = configApi.getString('backend.baseUrl');

  const [page, setPage] = useState<ConfluencePage | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!pageId) return;
    let cancelled = false;
    setLoading(true);
    setError('');
    setPage(null);

    identityApi.getCredentials()
      .then(credentials =>
        fetch(`${baseUrl}/api/custom-api/confluence/client`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${credentials.token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            path: `/rest/api/content/${pageId}`,
            method: 'GET',
            params: { expand: 'body.export_view,title' },
          }),
        }),
      )
      .then(r => {
        if (!r.ok) throw new Error(`Error ${r.status}`);
        return r.json();
      })
      .then((data: { title: string; body: { export_view: { value: string } } }) => {
        if (!cancelled) setPage({ title: data.title, html: data.body?.export_view?.value ?? '' });
      })
      .catch((err: any) => { if (!cancelled) setError(String(err)); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [pageId, baseUrl, identityApi]);

  return { page, loading, error };
}
